var _defs, _ellipse, _path, _path2, _line, _line2, _line3, _line4, _line5, _line6, _ellipse2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPriceDifference(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1a242d;}.cls-2,.cls-3,.cls-4,.cls-5,.cls-6{fill:none;stroke:#1a242d;stroke-miterlimit:10;}.cls-2{stroke-linecap:round;}.cls-2,.cls-3{stroke-width:0.9px;}.cls-4{stroke-width:0.75px;}.cls-5{stroke-width:0.25px;}.cls-6{stroke-width:0.5px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bruno") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 18.04,
    cy: 16.58,
    rx: 0.51,
    ry: 0.52
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.13,14.51H18a.43.43,0,0,1-.38-.43l-.29-3.29c0-.27.15-.51.36-.51h.7c.23,0,.41.26.39.55l-.28,3.27A.4.4,0,0,1,18.13,14.51Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.27,16.71H1.58a.38.38,0,0,1-.38-.38V7.07a.39.39,0,0,1,.38-.39H22.42a.39.39,0,0,1,.38.39V9.72"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3.47,
    y1: 8.32,
    x2: 3.47,
    y2: 15.39
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5.16,
    y1: 8.32,
    x2: 5.16,
    y2: 14.27
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 6.66,
    y1: 8.32,
    x2: 6.66,
    y2: 14.27
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 7.74,
    y1: 8.32,
    x2: 7.74,
    y2: 15.39
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 9.32,
    y1: 8.32,
    x2: 9.32,
    y2: 14.27
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 11.36,
    y1: 8.32,
    x2: 11.36,
    y2: 15.39
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 17.98,
    cy: 13.69,
    rx: 4.81,
    ry: 4.85
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceDifference);
export default __webpack_public_path__ + "static/media/price_difference.b2347fef14d0e92b073dd8ac6cd03d64.svg";
export { ForwardRef as ReactComponent };